<template lang="pug">
  .activity
    .activity-top
      router-link(to="/activity/new").activity-add-new
        svgicon(name='plus')
        span Новое мероприятие
      .activity-stat
        .activity-stat__item.item-stat
          .item-stat__title Доход
          .item-stat__text Поступило на счет сегодня
          .item-stat__number + 52 000 р.
        .activity-stat__item.item-stat
          .item-stat__title Заказы
          .item-stat__text Оплачены сегодня
          .item-stat__number 15
        .activity-stat__item.item-stat
          .item-stat__title Продано билетов
          .item-stat__text 3 мероприятия
          .item-stat__number 25
        .activity-stat__item.item-stat
          .item-stat__title Просмотров виджета
          .item-stat__text 3,1 % конверсия
          .item-stat__number 24 580
    .activity-my
      h1.h2 Мои мероприятия
      .activity-filter.filter
        .filter-item
          v-select(
            :options=['По дате начала', 'По статусу', 'По названию']
            :searchable="false"
            :clearable="false" 
            :placeholder="'Показать'" 
            v-on="sort"
            v-model='filters.sort'
            ).form__select.form__select--filter
        template(v-if="windowWidth > 991")
          .filter-item.filter-item--title
            v-select(
              :options=['Все', 'Встреча с Константином', 'Концерт группы «Пропаганда»', 'Встреча с Сёминым']
              :clearable="false" 
              :placeholder="'Название'" 
              v-on="filter"
              v-model='filters.title'
              ).form__select.form__select--fixwidth 
                template(v-slot:no-options) Извините, нет подходящих вариантов.
          .filter-item.filter-item--city
            v-select(
              :options="cities"
              :clearable="false" 
              :placeholder="'Город'" 
              v-on="filter"
              v-model='filters.city'
              ).form__select.form__select--fixwidth 
                template(v-slot:no-options) Извините, нет подходящих вариантов.
          .filter-item.filter-item--place
            v-select(
              :options="activityPlace"
              :clearable="false" 
              :placeholder="'Площадка'" 
              v-on="filter"
              v-model='filters.place'
              ).form__select.form__select--fixwidth 
                template(v-slot:no-options) Извините, нет подходящих вариантов.
          .filter-item.filter-item--calendar
            date-picker(
              v-on="filter"
              v-model="filters.calendar" 
              v-on:clear="clear"
              range 
              format="DD.MM.YYYY" 
              placeholder='Выберите даты')
        template(v-else)
          a(href="#" @click.prevent="filterMob = true").filter-mob
            svgicon(name='filter')
          .filter-mob-hidden(v-show="filterMob")
            a(href="#" @click.prevent="filterMob = false").filter-mob__back
              svgicon(name="arrow" dir="right")
              span Фильтры
            .filter-item.filter-item--title
              v-select(
                :options=['Все', 'Встреча с Константином', 'Концерт группы «Пропаганда»', 'Встреча с Сёминым']
                :clearable="false" 
                :placeholder="'Название'" 
                v-on="filter"
                v-model='filters.title'
                ).form__select.form__select--fixwidth 
                  template(v-slot:no-options) Извините, нет подходящих вариантов.
            .filter-item.filter-item--city
              v-select(
                :options="cities"
                :clearable="false" 
                :placeholder="'Город'" 
                v-on="filter"
                v-model='filters.city'
                ).form__select.form__select--fixwidth 
                  template(v-slot:no-options) Извините, нет подходящих вариантов.
            .filter-item.filter-item--place
              v-select(
                :options="activityPlace"
                :clearable="false" 
                :placeholder="'Площадка'" 
                v-on="filter"
                v-model='filters.place'
                ).form__select.form__select--fixwidth 
                  template(v-slot:no-options) Извините, нет подходящих вариантов.
            .filter-item.filter-item--calendar
              date-picker(
                v-on="filter"
                v-model="filters.calendar" 
                v-on:clear="clear"
                range 
                format="DD.MM.YYYY" 
                placeholder='Выберите даты')
          
      .activity-active
        h3.h3.activity-active__title Активные мероприятия
        .activity-active__content
          template(v-if="visibleItems > 0")
            p.no-result Нет подходящих вариантов
          .activity-table(v-else)
            .activity-table__title
              .activity-table__th.at-col-1 Мероприятие
              .activity-table__th.at-col-2 Город
              .activity-table__th.at-col-3 Площадка
              .activity-table__th.at-col-4 Дата начала
              .activity-table__th.at-col-5 
            .activity-table__content
              template(v-if="windowWidth > 767")
                .activity-table__item.item-activity(
                  v-for='activity in activities'
                  :key="activity.id" 
                  :class="activity.pin ? 'item-activity--pin' : false"
                  v-if="activity.visible"
                  @sortActivitiesPin()
                  )
                  .item-activity__activity.at-col-1 
                    .item-activity__ava(:class="activity.avaColor ? 'item-activity__ava--'+activity.avaColor : false")
                      template(v-if="activity.ava !== ''")
                        img(:src="require('@/assets/img/'+activity.ava)"  alt='ava')
                      template(v-else)
                        | {{ activity.avaLetter }}
                    .item-activity__info
                      router-link(to="/activity/summary").item-activity__name
                        span {{ activity.title }}
                      .item-activity__status(:class="'item-activity__status--'+activity.status") {{ activity.statusText }}
                  .item-activity__city.at-col-2 {{ activity.city }}
                  .item-activity__area.at-col-3 {{ activity.place }}
                  .item-activity__date.at-col-4 {{ activity.date }} 
                    br
                    |{{ activity.time }}
                  .item-activity__actions.at-col-5 
                    template(v-if="activity.status === 'planning'")
                      a(href='#').item-activity__btn.item-activity__btn--start Начать продажи
                        svgicon(name='arrow' dir="left")
                    template(v-if="activity.status === 'pause'")
                      a(href='#').item-activity__btn.item-activity__btn--reload Возобновить продажи
                        svgicon(name='reload')
                    template(v-if="activity.status === 'on-sale'")
                      a(href='#').item-activity__btn.item-activity__btn--pause Остановить продажи
                        svgicon(name='pause')
                    router-link(to="/activity/preview").item-activity__preview Предпросмотр
                    a(href='#' :class="activity.pin ? 'active' : false" @click.prevent="isPin(activity)").item-activity__pin
                      svgicon(name='pin')
              template(v-else)
                .activity-table__item.item-activity(
                  v-for='activity in activities'
                  :key="activity.id" 
                  :class="activity.pin ? 'item-activity--pin' : false"
                  v-if="activity.visible"
                  @sortActivitiesPin(),
                  )
                  .item-activity__ava(:class="activity.avaColor ? 'item-activity__ava--'+activity.avaColor : false")
                    template(v-if="activity.ava !== ''")
                      img(:src="require('@/assets/img/'+activity.ava)"  alt='ava')
                    template(v-else)
                      | {{ activity.avaLetter }}
                  .item-activity__info
                    router-link(to="/activity/summary").item-activity__name
                      span {{ activity.title }}
                    .item-activity__text
                      span.item-activity__city {{ activity.city }}, 
                      span.item-activity__area {{ activity.place }}, 
                      span.item-activity__date {{ activity.date }} {{ activity.time }}
                      .item-activity__status(:class="'item-activity__status--'+activity.status") {{ activity.statusText }}
                  .item-activity__actions
                    a(href='#' @click.prevent="mobMenu(activity)").item-activity__actions-link 
                      svgicon(name='more')
                    .item-activity__actions-hidden.actions-hidden(v-show="actionsHidden && actionsId === activity.id")
                      template(v-if="activity.status === 'planning'")
                        a(href='#').actions-hidden__link Начать продажи
                          svgicon(name='arrow' dir="left")
                      template(v-if="activity.status === 'pause'")
                        a(href='#').actions-hidden__link Возобновить продажи
                          svgicon(name='arrow' dir="left")
                      template(v-if="activity.status === 'on-sale'")
                        a(href='#').actions-hidden__link Остановить продажи
                          svgicon(name='arrow' dir="left")
                      router-link(to="/activity/preview").actions-hidden__link Предпросмотр
                        svgicon(name='arrow' dir="left")
                    a(href='#' :class="activity.pin ? 'active' : false" @click.prevent="isPin(activity)").item-activity__pin
                      svgicon(name='pin')

              
     
      .activity-arhive
        a(href='#' @click.prevent="arhiveBlock()").h3.activity-arhive__title Архив мероприятий, {{ activitiesArchive.length }}
          svgicon(name='arrow')
        transition(name="fade" )
          .activity-arhive__content(v-if="arhive") 
            template(v-if="visibleItemsArhive > 0")
              p.no-result Нет подходящих вариантов
            .activity-table(v-else)
              .activity-table__title
                .activity-table__th.at-col-1 Мероприятие
                .activity-table__th.at-col-2 Город
                .activity-table__th.at-col-3 Площадка
                .activity-table__th.at-col-4 Дата начала
                .activity-table__th.at-col-5 
              .activity-table__content
                template(v-if="windowWidth > 767")
                  .activity-table__item.item-activity(
                    v-for='activity in activitiesArchive'
                    :key="activity.id" 
                    :class="activity.pin ? 'item-activity--pin' : false"
                    v-if="activity.visible"
                    @sortActivitiesPin(),
                    )
                    .item-activity__activity.at-col-1 
                      .item-activity__ava(:class="activity.avaColor ? 'item-activity__ava--'+activity.avaColor : false")
                        template(v-if="activity.ava !== ''")
                          img(:src="require('@/assets/img/'+activity.ava)"  alt='ava')
                        template(v-else)
                          | {{ activity.avaLetter }}
                      .item-activity__info
                        .item-activity__name  {{ activity.title }}
                        .item-activity__status(:class="'item-activity__status--'+activity.status") {{ activity.statusText }}
                    .item-activity__city.at-col-2 {{ activity.city }}
                    .item-activity__area.at-col-3 {{ activity.place }}
                    .item-activity__date.at-col-4 {{ activity.date }} 
                      br
                      |{{ activity.time }}
                    .item-activity__actions.at-col-5 
                      template(v-if="activity.status === 'archive' || 'cancel'")
                        .item-activity__end Мероприятие завершено
                      .item-activity__preview Предпросмотр
                      a(href='#' :class="activity.pin ? 'active' : false" @click.prevent="isPin(activity)").item-activity__pin
                        svgicon(name='pin')
                template(v-else)
                  .activity-table__item.item-activity(
                    v-for='activity in activitiesArchive'
                    :key="activity.id" 
                    :class="activity.pin ? 'item-activity--pin' : false"
                    v-if="activity.visible"
                    @sortActivitiesPin(),
                    )
                    .item-activity__ava(:class="activity.avaColor ? 'item-activity__ava--'+activity.avaColor : false")
                      template(v-if="activity.ava !== ''")
                        img(:src="require('@/assets/img/'+activity.ava)"  alt='ava')
                      template(v-else)
                        | {{ activity.avaLetter }}
                    .item-activity__info
                      .item-activity__name  {{ activity.title }}
                      .item-activity__text
                        span.item-activity__city {{ activity.city }}, 
                        span.item-activity__area {{ activity.place }}, 
                        span.item-activity__date {{ activity.date }} {{ activity.time }}
                        .item-activity__status(:class="'item-activity__status--'+activity.status") {{ activity.statusText }}
                    .item-activity__actions
                      a(href='#' @click.prevent="mobMenuArhive(activity)").item-activity__actions-link 
                        svgicon(name='more')
                      .item-activity__actions-hidden.actions-hidden(v-show="actionsHiddenArhive && actionsIdArhive == activity.id")
                        template(v-if="activity.status == 'archive' || 'cancel'")
                          .item-activity__end Мероприятие завершено
                        .actions-hidden__link Предпросмотр
                          svgicon(name='arrow' dir="left")
                      a(href='#' :class="activity.pin ? 'active' : false" @click.prevent="isPin(activity)").item-activity__pin
                        svgicon(name='pin')

    .increase-sales
      h2.h2.increase-sales__title Как увеличить продажи?
      .increase-sales__content
        a(href='#').increase-sales__item
          span Запуститe e-mail рассылку
          svgicon(name='email') 
        a(href='#').increase-sales__item
          span Закажите рассылку SMS
          svgicon(name='sms') 
        a(href='#').increase-sales__item
          span Рассчитайте продвижение
          svgicon(name='cash') 

          
</template>

<script>
import { mapGetters } from 'vuex';
import { mapMutations } from 'vuex';
export default {
  name: 'Activity',
  data: function() {
    return {
      arhive: false,
      windowWidth: null,
      actionsHidden: false,
      actionsId: null,
      actionsHiddenArhive: false,
      actionsIdArhive: null,
      filterMob: false,
    }
  },
  mounted() {
    this.sortActivitiesPin(),
    this.$nextTick(function() {
      window.addEventListener('resize', this.resize);
      this.resize()
    })
  },
  methods: {
    ...mapMutations([
      'onFilters',
    ]),
    arhiveBlock() {
      return this.arhive = !this.arhive
    },
    isPin(activity) {
      return activity.pin = !activity.pin, this.sortActivitiesPin();
    },
    resize() {
      this.windowWidth = document.documentElement.clientWidth;
    },
    mobMenu(activity) {
      if (this.actionsId == activity.id) {
        this.actionsHidden = !this.actionsHidden;
        this.actionsId = activity.id;
        this.actionsHiddenArhive = false;
      } else {
        this.actionsHidden = true;
        this.actionsId = activity.id;
        this.actionsHiddenArhive = false;
      }
    },
    mobMenuArhive(activity) {
      if (this.actionsIdArhive == activity.id) {
        this.actionsHiddenArhive = !this.actionsHiddenArhive;
        this.actionsIdArhive = activity.id;
        this.actionsHidden = false;
      } else {
        this.actionsHiddenArhive = true;
        this.actionsIdArhive = activity.id;
        this.actionsHidden = false;
      }
    },
    sortActivitiesPin() {
      this.activities.sort(function(a, b) { 
        return b.pin - a.pin;
      });
    },
    sortActivitiesTitle() {
      this.activities.sort(function(a, b) { 
        if (a.title > b.title) {
          return 1;
        }
        if (a.title < b.title) {
          return -1;
        }
        return 0;
      });
      this.activitiesArchive.sort(function(a, b) { 
        if (a.title > b.title) {
          return 1;
        }
        if (a.title < b.title) {
          return -1;
        }
        return 0;
      });
    },
    sortActivitiesStatus() {
      this.activities.sort(function(a, b) { 
        if (a.statusText > b.statusText) {
          return 1;
        }
        if (a.statusText < b.statusText) {
          return -1;
        }
        return 0;
      });
      this.activitiesArchive.sort(function(a, b) { 
        if (a.statusText > b.statusText) {
          return 1;
        }
        if (a.statusText < b.statusText) {
          return -1;
        }
        return 0;
      });
      return false;
    },
    sortActivitiesDate() {
      const months = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];
      this.activities.sort(function(a, b) {
        let day_a = a.date.slice(0,2);
        let month_a = months.indexOf(a.date.slice(3,-5));
        let year_a = a.date.slice(-4);
        let date_a = new Date(year_a,month_a,day_a);
        let day_b = b.date.slice(0,2);
        let month_b = months.indexOf(b.date.slice(3,-5));
        let year_b = b.date.slice(-4);
        let date_b = new Date(year_b,month_b,day_b);
        if (date_a > date_b) {
          return 1;
        }
        if (date_a < date_b) {
          return -1;
        }
        return 0;
      });
      this.activitiesArchive.sort(function(a, b) {
        let day_a = a.date.slice(0,2);
        let month_a = months.indexOf(a.date.slice(3,-5));
        let year_a = a.date.slice(-4);
        let date_a = new Date(year_a,month_a,day_a);
        let day_b = b.date.slice(0,2);
        let month_b = months.indexOf(b.date.slice(3,-5));
        let year_b = b.date.slice(-4);
        let date_b = new Date(year_b,month_b,day_b);
        if (date_a > date_b) {
          return 1;
        }
        if (date_a < date_b) {
          return -1;
        }
        return 0;
      });
    },
    clear(){
      this.onFilters({type: 'calendar', amount: null});
    },
  },
  computed: {
    ...mapGetters([
      'cities',
      'activityPlace',
      'activities',
      'activitiesArchive',
      'filters',
    ]),
    sort(){
      switch (this.filters.sort) {
        case "По статусу":
          this.sortActivitiesStatus();
          break;
        case "По дате начала":
          this.sortActivitiesDate();
          break;
        default: this.sortActivitiesTitle();
          break;
      }
      this.sortActivitiesPin();
      return false;
    },
    filter() {
      if(event != undefined) {
        const current = event.target.closest('.filter-item');
        const date = event.target.closest('.mx-datepicker-popup');
        if(current != null) {
          if(current.classList.contains("filter-item--title")) {
            this.onFilters({type: 'city', amount: null});
            this.onFilters({type: 'place', amount: null});
            this.onFilters({type: 'calendar', amount: null});
          }
          if(current.classList.contains("filter-item--city")) {
            this.onFilters({type: 'title', amount: null});
            this.onFilters({type: 'place', amount: null});
            this.onFilters({type: 'calendar', amount: null});
          }
          if(current.classList.contains("filter-item--place")) {
            this.onFilters({type: 'title', amount: null});
            this.onFilters({type: 'city', amount: null});
            this.onFilters({type: 'calendar', amount: null});
          }
        }
        if(date != null) {
          this.onFilters({type: 'title', amount: null});
          this.onFilters({type: 'city', amount: null});
          this.onFilters({type: 'place', amount: null});
        }
      }
      const title = this.filters.title;
      const city = this.filters.city;
      const place = this.filters.place;
      const calendar = this.filters.calendar;
      const arr = [this.activities, this.activitiesArchive];
      for(let i = 0; i < arr.length; i++) {
        const el = arr[i];
        for (let i = 0; i < el.length; i++) {
          const item = el[i];
          item.visible = false;
          if(title == 'Все') {
            this.onFilters({type: 'title', amount: null});
            item.visible = true;
          }
          if(city == 'Все') {
            this.onFilters({type: 'city', amount: null});
            item.visible = true;
          }
          if(place == 'Все') {
            this.onFilters({type: 'place', amount: null});
            item.visible = true;
          }
          if (title == null && city == null && place == null && calendar == null) {
            item.visible = true;
          } else {
            if(item.title == title) {
              item.visible = true;
            }
            if(item.city == city) {
              item.visible = true;
            }
            if(item.place == place) {
              item.visible = true;
            }
            if(calendar != null) {
              const months = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];
              const day = item.date.slice(0,2);
              const month = months.indexOf(item.date.slice(3,-5));
              const year = item.date.slice(-4);
              const date = new Date(year, month, day);
              if(calendar[0] < date && date < calendar[1]) {
                item.visible = true;
              }
            }
          }
        }
      }
      return false;
    },
    visibleItems(){
      let visibleItems = 0;
      this.activities.forEach(item => {
        if(item.visible == false) {
          visibleItems += 1;
        }
      });
      return this.activities.length == visibleItems;
    },
    visibleItemsArhive(){
      let visibleItemsArhive = 0;
      this.activitiesArchive.forEach(item => {
        if(item.visible == false) {
          visibleItemsArhive += 1;
        }
      });
      return this.activitiesArchive.length == visibleItemsArhive;
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize);
  }
}
</script>

<style lang="scss">
.activity-top{
  margin: 20px 40px 45px; 
  display: flex;
}
.activity-add-new{
  flex-shrink: 0;
  margin-right: 20px;
  box-shadow: 0 0 10px rgba(196, 202, 214, 0.8);
  background-color: #008cff;
  text-decoration: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 45px;
  color: #fff;
  .svg-icon{
    display: block;
    margin-bottom: 15px;
    width: 21px;
    height: 21px;
  }
  &:hover{
    background-color: #026ac0;
  }
}
.activity-stat{
  display: flex;
  flex-grow: 1;
}
.item-stat{
  border: 1px solid #e4e4e4;
  background-color: #ffffff;
  width: 25%;
  padding: 20px 30px;
  margin-left: -1px;
  color: #161616;
  &__title{
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 15px;
  }
  &__text{
    font-size: 16px;
    margin-bottom: 10px;
  }
  &__number{
    font-size: 25px;
    font-weight: 700;
  }
}
.activity-my{
  margin: 45px 40px;
}
.activity-active{
  margin-bottom: 40px;
}
.activity-table{
  width: 100%;
  &__title{
    display: flex;
    margin-bottom: 10px;
    padding: 0px 25px;
  }
  &__th{
    color: #9398a2;
    font-size: 14px;
  }
  &__content{    
    box-shadow: 0 0 10px rgba(196, 202, 214, 0.8);
  }
}
.item-activity{
  display: flex;
  background-color: #ffffff;
  padding: 15px 25px;
  color: #161616;
  font-size: 14px;
  position: relative;
  &:before{
    content: '';
    display: block;
    position: absolute;
    top: -1px;
    left: 25px;
    width: calc(100% - 50px);
    height: 1px;
    background: #e4e4e4;
  }
  &:hover{
    background-color: #e7f1f8;
  }
  &:first-child:before{
    display: none;
  }
  &--pin{
    background-color: #f4f5f6;
  }
  &__activity{
    display: flex;
  }
  &__ava{
    width: 45px;
    height: 45px;
    border-radius: 50%;
    background-color: #78c076;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    margin-right: 10px;
    color: #fff;
    font-size: 24px;
    font-weight: 700;
    line-height: 45px;
    text-align: center;
    flex-shrink: 0;
    &--green{
      background: #78c076;
    }
    &--blue{
      background: #008cff;
    }
    &--fiolet{
      background: #865bf4;
    }
  }
  &__name{
    color: #161616;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 5px;
    text-decoration: none;
    display: block;
    span{
      border-bottom: 1px solid #161616;
      line-height: 22px;
    }
    &:hover span{
      border-bottom-color: transparent;
    }
  }
  &__status{
    font-size: 14px;
    font-weight: 600;
    &--planning{
      color: #008cff;
    }
    &--pause{
      color: #e67c27;
    }
    &--on-sale{
      color: #36b067;
    }
    &--arhive{
      color: #7b7b7b;
    }
    &--cancel{
      color: #e67c27;
    }
  }
  &__date{
    line-height: 20px;
  }
  &__actions{
    display: flex;
    align-items: center;
  }
  &__btn{
    color: #161616;
    font-size: 16px;
    font-weight: 600;
    padding: 7px 12px 8px 15px;
    border-radius: 17px;
    border: 1px solid #ccc;
    background-color: #fff;
    text-decoration: none;
    display: flex;
    align-items: center;
    margin-right: auto;
    &:hover{
      background-color: #d3d3d3;
    }
    .svg-icon{
      margin-left: 10px;
    }
    &--start{
      .svg-icon{
        color: #e67c27;
        width: 15px;
        height: 10px;
      }
    }
    &--reload{
      .svg-icon{
        color: #008cff;
        width: 17px;
        height: 21px;
      }
    }
    &--pause{
      .svg-icon{
        color: #00a651;
        width: 10px;
        height: 15px;
      }
    }
  }
  &__preview{
    color: #fff;
    font-size: 16px;
    text-decoration: none;
    display: flex;
    border-radius: 18px;
    background-color: #7b7b7b;
    height: 35px;
    line-height: 35px;
    margin-left: 15px;
    padding: 0 15px;
    &:hover{
      background-color: #008cff;
      color: #fff;
    }
  }
  &__pin{
    margin-left: 10px;
    color: #d9d9d9;
    &.active{
      color: #7b7b7b;
    }
    &:hover{
      color: #b6b6b6;
    }
  }
  &__end{
    color: #7b7b7b;
    font-size: 16px;
    font-weight: 600;
    margin-right: auto;
  }
}
.at-col-1{
  width: 365px;
}
.at-col-2{
  width: 190px;
}
.at-col-3{
  width: 180px;
}
.at-col-4{
  width: 130px;
}
.at-col-5{
  width: 450px;
  margin-left: auto;
}
.activity-arhive{
  &__title{
    text-decoration: none;
    .svg-icon{
      margin-left: 10px;
      color: #161616;
      width: 14px;
      height: 9px;
    }
  }
  &__content{
    padding-top: 15px;
  }
  .activity-table__content{
    box-shadow: none;
    border: 1px solid #e4e4e4;
  }
  .item-activity{
    background: transparent;
    color: #7b7b7b;
    &__ava{
      background-color: #d9d9d9;
      img{
        filter: grayscale(1) opacity(0.5);
      }
    }
    &__name{
      color: #7b7b7b;
      cursor: default;
      &:hover{
        border-bottom-color: #7b7b7b;
      }
    }
    &__preview{
      cursor: default;
      background-color: #d9d9d9;
    }
    &__pin{
      cursor: default;
      color: #d9d9d9;
    }
  }
}
.increase-sales{
  margin: 40px 40px 20px;
  &__content{
    display: flex;
  }
  &__item{
    border: 1px solid #e4e4e4;
    background-color: #fff;
    text-decoration: none;
    padding: 15px 20px 15px 30px;
    display: flex;
    align-items: center;
    color: #161616;
    font-size: 16px;
    font-weight: 700;
    margin-right: 20px;
    .svg-icon{
      color: #008cff;
      display: block;
      margin-left: 15px;
      height: 28px;
      width: 28px;
      flex-shrink: 0;
    }
    &:hover{
      box-shadow: 0 0 10px rgba(196, 202, 214, 0.8);
    }
  }
}

.actions-hidden{
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 10;
  box-shadow: 0 0 10px 0 rgba(196, 202, 214, 0.8);
  background-color: #ffffff;
  width: 100%;
  padding-top: 30px;
  &:before{
    content: '';
    position: absolute;
    top: 10px;
    left: 50%;
    width: 60px;
    height: 6px;
    border-radius: 3px;
    background-color: #eee;
    margin-left: -30px;
  }
  .item-activity__end,
  &__link{
    border: none;
    background: none;
    color: #161616;
    font-size: 18px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #e4e4e4;
    text-decoration: none;
    padding: 20px;
    &:last-child{
      border-bottom: none;
    }
    .svg-icon{
      fill: #9a9a9a;
    }
  }
}

.activity-arhive{
  .actions-hidden{
    .item-activity__end,
    &__link{
      color: #9a9a9a;
      font-weight: 400;
    }
  }
}

.no-result {
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  margin: 40px 0;
}

@media (max-width: 1439px)  {
  .activity-table__title{
    padding: 0 15px;
  }
  .item-activity{
    padding: 15px;
  }
  .at-col-1 {
    width: 210px;
    padding-right: 20px;
  }
  .at-col-2 {
    width: 140px;
    padding-right: 10px;
  }
  .at-col-4{
    padding-right: 20px;
  }
  .item-activity__btn{
    font-size: 14px;
  }
}
@media (max-width: 1199px)  {
  .item-activity__actions{
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    position: relative;
  }
  .item-activity__btn{
    margin-right: 0;
    margin-bottom: 10px;
    text-align: center;
  }
  .item-activity__end{
    text-align: right;
    margin-right: 0;
    margin-bottom: 10px;
  }
  .item-activity__pin{
    position: absolute;
    top: 50%;
    right: 0;
    margin-top: -8px;
  }
  .at-col-5 {
    width: 220px;
    padding-right: 30px;
  }
  .activity-add-new{
    padding: 20px;
  }
  .item-stat{
    padding: 20px 15px;
  }
  .item-stat__title{
    font-size: 15px;
  }
  .item-stat__text {
    font-size: 15px;
  }
  .item-stat__number{
    font-size: 20px;
  }
}
@media (max-width: 991px)  {
  .item-activity__activity{
    flex-direction: column;
  }
  .item-activity__ava{
    margin-right: 0;
    margin-bottom: 5px;
  }
  .at-col-1 {
    width: 180px;
    padding-right: 10px;
  }
  .at-col-2{
    width: 100px;
  }
  .at-col-3 {
    width: 150px;
  }
  .at-col-4 {
    padding-right: 10px;
  }
  .item-activity__name{
    font-size: 14px;
  }
  .item-activity{
    font-size: 13px;
  }
  .activity-top,
  .activity-my{
    margin: 20px;
  }
  .increase-sales{
    margin: 20px 20px;
  }
  .activity-table__th{
    font-size: 13px;
  }
  .activity-add-new{
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    box-sizing: border-box;
    flex-direction: row;
    font-weight: 700;
    .svg-icon{
      margin-right: 15px;
      margin-bottom: 0;
    }
  }
}
@media (max-width: 767px)  {
  .activity-top,
  .activity-my{
    margin: 20px 0 20px 20px;
  }
  .increase-sales{
    margin: 20px 20px;
  }
  .increase-sales__content{
    flex-direction: column;
  }
  .increase-sales__item{
    margin-right: 0;
    margin-bottom: 20px;
    justify-content: center;
  }
  .activity-stat{
    overflow: auto;
  }
  .item-stat{
    width: 200px;
    flex-shrink: 0;
    &:first-child{
      margin-left: 0;
    }
  }
  .activity-table__title{
    padding: 0;
  }
  .activity-table__th{
    display: none;
    &:first-child{
      display: block;
    }
  }
  .item-activity__ava{
    margin-bottom: 0;
    margin-right: 10px;
  }
  .item-activity__info{
    flex-grow: 1;
  }
  .item-activity__pin{
    position: static;
    margin-top: 20px;
    width: 23px;
    height: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .item-activity__actions-link{
    width: 23px;
    height: 23px;
    color: #7b7b7b;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .item-activity__status{
    margin-top: 5px;
  }
  .filter-mob{
    margin-right: 0;
  }
}
@media (max-width: 479px)  {
  .increase-sales__item{
    font-size: 14px;
    padding: 15px;
    justify-content: space-between;
  }
}
</style>